export default __webpack_public_path__ + "static/media/home_product_img4_En.170e5600.webp";